import React from 'react';
import isArray from 'lodash/isArray';
import { sprintf } from 'sprintf';
import now from 'lodash/now';

import { formatPrice } from 'services/stringFormating';
import * as Types from 'types';

type Props = {
  maxBid?: Types.Bid;
  userBid?: Types.Bid;
  auction: Types.Auction;
};

export const CurrentBid: React.FC<Props> = ({ maxBid, userBid, auction }) => {
  let bidStatusString: string | string[] = '';
  const { winningBidId, endsAt, startsAt } = auction;

  const auctionHasStarted = startsAt <= now();
  const auctionHasEnded = endsAt && endsAt < now();

  if (!auctionHasStarted) {
    bidStatusString = "The auction hasn't started yet";
  } else if (auctionHasEnded && winningBidId) {
    bidStatusString = 'The auction has ended';
    const userWonTheAuction = userBid && winningBidId === userBid.id;
    if (userWonTheAuction) {
      bidStatusString = ['Final price', bidStatusString, 'You have won the auction!'];
    } else {
      bidStatusString = ['Final price', bidStatusString];
    }
    // Pending results
  } else if (auctionHasEnded && !winningBidId) {
    bidStatusString = ['Online bidding has ended', 'Waiting for results'];
    if (userBid && maxBid && maxBid.id === userBid.id) {
      bidStatusString = [
        'Online bidding has ended',
        sprintf('Your bid of %s was submitted to the auction', formatPrice(userBid.priceCents)),
      ];
    }
  } else if (maxBid && userBid && maxBid.user.id === userBid.user.id) {
    bidStatusString = 'You have the highest bid';
  } else if (maxBid && userBid) {
    bidStatusString = [
      'You have been outbid',
      sprintf('Next bid min %s', formatPrice((maxBid ? maxBid.priceCents : 0) + 100)),
    ];
  } else if (!maxBid) {
    bidStatusString = 'Place your bid';
  } else if (maxBid) {
    bidStatusString = 'Current highest bid';
  }

  return (
    <div className='mb-1'>
      <div className='row no-gutters'>
        <b className='col-auto headline'>
          {maxBid ? formatPrice(maxBid.priceCents, 'USD') : 'N/A'}
        </b>
      </div>
      <div className='key-value key-value__value mb-mini'>
        {isArray(bidStatusString)
          ? bidStatusString.map((text, index) => (
              <span key={index}>
                {text}
                <br />
              </span>
            ))
          : bidStatusString}
      </div>
    </div>
  );
};
